// extracted by mini-css-extract-plugin
export default {"date":"DisplayDate_date__mju0R","icon":"DisplayDate_icon__eQfaL","days":"DisplayDate_days__0ZCkp"};